import { makeStyles } from 'tss-react/mui';

import { pickIf } from '../../../../../utils/pickIf';

export const useStyles = makeStyles()(
  (theme, { isKiteUser, order_limit, isDesktopMode } = {}) => ({
    clickable: { cursor: 'pointer' },
    audienceLabel: {
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '20px',
      color: '#54565B',
      padding: '5px 10px',
      borderRadius: '5px',
      backgroundColor: '#F4F4F4',
    },
    infoContainer: {
      '& > div:nth-child(3)': {
        [theme.breakpoints.down('md')]: {
          width: 95,
          height: 24,
        },
        [theme.breakpoints.downLandscape('md')]: {
          ...(theme.isMobileDevice && {
            width: 95,
            height: 24,
          }),
        },
      },
    },
    qtyInfoText: {
      fontWeight: '700',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.1px',
      color: pickIf(isKiteUser, theme.palette.primary1, theme.palette.pressed),
      '&:nth-child(2)': {
        marginBottom: theme.spacing(2),
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '10px',
        lineHeight: '12px',
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: '10px',
          lineHeight: '12px',
        }),
      },
    },
    listCardQtyInfo: {
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.1px',
      color: '#54565B',
    },
    productInfo: {
      '&  *': {
        fontSize: '14px',
      },
    },
    productInfoHeader: {
      fontWeight: pickIf(isKiteUser, '700', '600'),
    },
    productInfoText: {
      fontWeight: pickIf(isKiteUser, '400', '600'),
    },
    inStockQty: {
      marginBottom: pickIf(order_limit === null, 36, 0),
    },
    productDescription: {
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word',
      [theme.breakpoints.down('md')]: {
        WebkitLineClamp: 2,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          WebkitLineClamp: 2,
        }),
      },
    },
    productMobileDescription: {
      fontSize: '14px',
      fontWeight: '700',
      [theme.breakpoints.down('md')]: {
        fontSize: '10px',
        fontWeight: '600',
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: '10px',
          fontWeight: '600',
        }),
      },
    },
    buttonContainer: {
      alignItems: 'end',
      display: 'flex',
      '& > div:nth-child(1)': {
        [theme.breakpoints.down('lg')]: {
          width: 130,
          height: 34,
        },
        [theme.breakpoints.downLandscape('lg')]: {
          ...(theme.isMobileDevice && {
            width: 130,
            height: 34,
          }),
        },
      },
    },
    closeIcon: {
      top: 3,
      right: -40,
      [theme.breakpoints.down('lg')]: {
        top: 0,
        right: 0,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          top: 0,
          right: 0,
        }),
      },
    },
    approvalLabel: {
      position: 'absolute',
      top: pickIf(isDesktopMode, '100%', 'unset'),
      right: pickIf(isDesktopMode, '0', 'unset'),
      bottom: pickIf(!isDesktopMode, '16px', 'unset'),
      left: pickIf(!isDesktopMode, '16px', 'unset'),
      maxWidth: pickIf(isDesktopMode, '145px', '185px'),
    },
    totalItems: {
      color: theme.palette.red,
    },
  }),
);
